<template>
  <div
    v-if="showControls"
    class="controls"
    :class="alignmentClass"
  >
    <sh-button
      v-if="cta1Href"
      class="cta"
      :[btnLinkKeyCTA1]="cta1Href"
      :color="getCtaColor(button1ColorValue)"
      :outline="hasOutline(button1ColorValue)"
      :target="cta1Target"
      :naked="displayCtaAsLink"
      :aria-label="cta1HiddenText || cta1Title"
    >
      {{ cta1Text }}
    </sh-button>
    <sh-button
      v-if="cta2Href"
      class="cta"
      :[btnLinkKeyCTA2]="cta2Href"
      :color="getCtaColor(button2ColorValue)"
      :outline="hasOutline(button2ColorValue)"
      :target="cta2Target"
      :naked="displayCtaAsLink"
      :aria-label="cta2HiddenText || cta2Title"
    >
      {{ cta2Text }}
    </sh-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CTA from '~/constants/appearance'
import { getButtonType } from '~/helpers/get-button-type'
import mapFields from '~/helpers/map-fields'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'EditorialCta',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },

    alignment: {
      type: String,
      default: 'Left',
      validator: value => ['Left', 'Center'].some(option => option === value)
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    ...mapFields({
      ctaAppearance: 'ctaAppearance.value',
      cta1Href: 'cta1.value.href',
      cta2Href: 'cta2.value.href',
      button1ColorValue: 'button1Color.value',
      button2ColorValue: 'button2Color.value',
      cta1Target: 'cta1.value.target',
      cta2Target: 'cta2.value.target',
      cta1Text: 'cta1.value.text',
      cta2Text: 'cta2.value.text',
      cta1Title: 'cta1.value.title',
      cta2Title: 'cta2.value.title',
      cta1HiddenText: 'cta1.value.data-hidden-text',
      cta2HiddenText: 'cta2.value.data-hidden-text'
    }),

    showControls () {
      return this.isEditMode || this.cta1Href || this.cta2Href
    },

    alignmentClass () {
      return `align-${this.alignment}`.toLowerCase()
    },

    displayCtaAsLink () {
      return this.ctaAppearance === CTA.LINK
    },

    btnLinkKeyCTA1 () {
      return getButtonType(this.cta1Href)
    },

    btnLinkKeyCTA2 () {
      return getButtonType(this.cta2Href)
    }
  },

  methods: {
    getCtaColor (ctaColorValue) {
      if (this.isDarkTheme && this.displayCtaAsLink) {
        return CTA.SECONDARY
      }

      return this.isDarkTheme && ctaColorValue === CTA.WHITE ?
        CTA.SECONDARY :
        CTA.PRIMARY
    },
    hasOutline (ctaColorValue) {
      if (this.displayCtaAsLink) return false
      return !this.isDarkTheme && ctaColorValue === CTA.WHITE
    }
  }
}
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: $space-060;

  .cta {
    @include stack-space($space-050);
  }

  @include tablet {
    flex-direction: row;

    .cta {
      @include inline-space($space-060);
      @include stack-space(0);
    }
  }

  &.align-left {
    justify-content: flex-start;
    align-items: flex-start;
  }

  &.align-center {
    justify-content: center;
    align-items: center;
  }
}
</style>
